import React from 'react';

const ResearchDisclaimer = ({ attribution }) => (
  <aside className="research-disclaimer" aria-label="Investment disclaimer">
    {attribution && <span className="research-disclaimer-attribution">
      REBELLIONAIRE.AI RESEARCH &mdash; {attribution}
    </span>}
    <strong>For informational and educational purposes only.</strong>{' '}
    Not investment advice or a recommendation to buy or sell any security.
    AI-generated content and third-party data may be inaccurate, incomplete, or outdated.
    Verify information independently. Investing involves risk, including loss of principal.{' '}
    <a href="/disclaimer">Read the full disclaimer</a>.
  </aside>
);

export default ResearchDisclaimer;
